import { motion } from "framer-motion";
import colors from "../../styles/colors";
import { useTranslation } from "react-i18next";


const TitleSection = () => {
  const { t } = useTranslation();
  return (
    <div
      className="w-full min-h-[50vh] max-h[50vh] p-8 flex flex-col justify-center items-start lg:px-20 lg:py-16"
      style={{ backgroundColor: colors.pastelCream }}  // Light cream háttérszín
    >
      {/* Cég neve */}
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false }}
        transition={{ duration: 0.8 }}
        className="text-6xl md:text-7xl lg:text-8xl font-serif text-transparent bg-clip-text mb-8"
        style={{
          backgroundImage: `linear-gradient(to right, ${colors.darkBrown}, ${colors.pantoneBrown})`, 
        }}
      >
        Uniart.
      </motion.h1>

      {/* subtitle */}
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="text-xl md:text-2xl lg:text-3xl font-serif"
        style={{ color: colors.darkBrown }}  // Dark brown szín
      >
        
        {t("homeTitleSecText")}
      </motion.p>
    </div>
  );
};

export default TitleSection;
